import { FC } from "react";
import { Typography, Switch, Stack, Tooltip } from "@mui/material";
import { useVirtualBatteries } from "./hooks/useVirtualBatteries";
import { useTranslation } from "react-i18next";
import { IBateriaVirtual } from "./types/virtualBattery";


export interface IVirtualBatteryDiscountToggleProps {
  bateriaVirtual: IBateriaVirtual;
  readOnly?: boolean;
  tooltip?: string;
}

const VirtualBatteryDiscountToggle: FC<IVirtualBatteryDiscountToggleProps> = ({
  bateriaVirtual,
  readOnly = false,
  tooltip
}) => {

  const { t } = useTranslation();

  const { 
    virtualBatteryTypes,
    handleBatteryTypeChange
  } = useVirtualBatteries();
  
  return (
    <Tooltip
      title={tooltip && t(tooltip)}
      placement="right"
      arrow
      disableFocusListener={!readOnly}
      disableHoverListener={!readOnly}
      disableTouchListener={!readOnly}
      slotProps={{
        popper: {
          modifiers: [{
            name: 'offset',
            options: {offset: [0, -5]}
          }]
        }
      }}
    >
      <Stack direction="row" width={"fit-content"}>
      
        <Typography
          variant="body1"
          style={{
            color: bateriaVirtual.gestio_descomptes === "aplicar" ? "gray" : "black",
            marginTop: '6px'
          }}
        >
          {t("common:text.generic_no")}
        </Typography>

        <Switch
          disabled={readOnly}
          checked={bateriaVirtual.gestio_descomptes === "aplicar"}
          onChange={(e) =>
            handleBatteryTypeChange(
              e.target.checked
                ? virtualBatteryTypes[1].name //"aplicar"
                : virtualBatteryTypes[0].name, //"no_aplicar"
                bateriaVirtual.id
            )
          }
        />

        <Typography
          variant="body1"
          style={{
            color: bateriaVirtual.gestio_descomptes === "aplicar" ? "black" : "gray",
            marginTop: '6px'
          }}
        >
          {t("common:text.generic_yes")}
        </Typography>
      </Stack>
    </Tooltip>
  );
};

export default VirtualBatteryDiscountToggle;
